import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";

const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: tokens.brand,
      light: tokens.brandMuted,
      dark: tokens.brandDeep,
      contrastText: "#ffffff",
    },
    secondary: {
      main: tokens.accent,
      light: "#4a8fb0",
      dark: tokens.accentHover,
      contrastText: "#ffffff",
    },
    error: {
      main: tokens.error,
    },
    success: {
      main: tokens.success,
    },
    warning: {
      main: tokens.highlight,
    },
    background: {
      default: tokens.surface,
      paper: tokens.paper,
    },
    text: {
      primary: tokens.text,
      secondary: tokens.textMuted,
    },
    divider: tokens.border,
  },
  typography: {
    fontFamily: tokens.fontSans,
    h1: {
      fontFamily: tokens.fontDisplay,
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontFamily: tokens.fontDisplay,
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontFamily: tokens.fontDisplay,
      fontWeight: 600,
    },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: {
      textTransform: "none",
      fontWeight: 600,
      letterSpacing: "0.01em",
    },
  },
  shape: {
    borderRadius: tokens.radiusMd,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarColor: `${tokens.borderStrong} transparent`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radiusMd,
          boxShadow: "none",
          "&:hover": { boxShadow: tokens.shadowSm },
        },
        containedPrimary: {
          background: `linear-gradient(180deg, ${tokens.brandMuted} 0%, ${tokens.brand} 100%)`,
          "&:hover": {
            background: tokens.brandDeep,
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: tokens.accentHover,
          },
        },
        outlined: {
          borderColor: tokens.borderStrong,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radiusMd,
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: tokens.borderStrong,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: "1px",
            borderColor: tokens.accent,
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
        elevation1: { boxShadow: tokens.shadowSm },
        elevation2: { boxShadow: tokens.shadowMd },
        elevation3: { boxShadow: tokens.shadowLg },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radiusLg,
          boxShadow: tokens.shadowSm,
          border: `1px solid ${tokens.border}`,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          borderRadius: tokens.radiusSm,
        },
      },
    },
  },
});

export default appTheme;
